export const SURVEY_HOME_CARD_CLICKED = 'survey_home_card_clicked';
export const SURVEY_HOME_PAGE_OPEN = 'survey_home_page_open';
export const SURVEY_OPEN = 'survey_open';
export const BH_CASH_API_LATENCY_FE = 'bhcash_api_latency_fe';
export const API_RETRIED_SUCCESS = 'api_retried_success';
